import { qsStringify } from '@voghion/fe-util';
/**
 * 获取 vue 路由路径
 * @param router
 * @returns
 */
export function getVueRoutePath(router) {
    var _a;
    const baseStr = router.options.history.base;
    const base = baseStr.includes('#') ? baseStr.split('#')[1] : baseStr;
    const { currentRoute } = router;
    const path = ((_a = currentRoute.value) === null || _a === void 0 ? void 0 : _a.path) || '/';
    return base + path;
}
/**
 * 获取 vue 路由 query 参数
 * @param router
 * @returns
 */
export function getVueRouteQuery(router) {
    var _a;
    const { currentRoute } = router;
    return qsStringify(((_a = currentRoute.value) === null || _a === void 0 ? void 0 : _a.query) || {});
}
